import * as Yup from 'yup';

const validationSchemaTruncatedCone = (t, containerType, columnMappings, globalState) => {
  const getCsv = (key) => columnMappings?.[key]?.mapping?.csvName;

  const baseSchema = {
    totalCapacity: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('totalCapacity') && columnMappings?.totalCapacity?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    // Optional, as in the barrel form: many containers have no usable capacity, and a
    // full container falls back to its total capacity.
    usableCapacity: Yup.object().shape({
      value: Yup.string(),
      unit: Yup.string(),
    }),
    diameterBond: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('heightUnderBung') && columnMappings?.heightUnderBung?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    // Specific validation for truncated cone diameter fields
    diameterDown: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('internalDiameterDown') && columnMappings?.internalDiameterDown?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    diameterUp: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('internalDiameterUp') && columnMappings?.internalDiameterUp?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    liquidHeight: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('liquidHeight') && columnMappings?.liquidHeight?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    emptyHeight: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('emptyHeight') && columnMappings?.emptyHeight?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    liquidVolume: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('liquidVolume') && columnMappings?.liquidVolume?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    tav: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('tav') && columnMappings?.tav?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    tavTemp: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('tavTemperature') && columnMappings?.tavTemperature?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
    volumeTemp: Yup.object().shape({
      value: Yup.string().when([], {
        is: () => getCsv('volumeTemperature') && columnMappings?.volumeTemperature?.enabled,
        then: (schema) => schema.required(t('validation.required_field')),
        otherwise: (schema) => schema,
      }),
      unit: Yup.string(),
    }),
  };

  return Yup.object().shape(baseSchema);
};

export default validationSchemaTruncatedCone;
